import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
// import { useSelector } from 'react-redux';

import { Col, Row, Form } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form'; // Importa useFormContext
import IconId from '../../../assets/new-icons/id-min.png';
import IconPassport from '../../../assets/new-icons/passport-min.png';
// import IconSign from '../../../assets/icon-sign.svg';
import { isEmptyObject } from '../../../utils';
import { useSelector } from 'react-redux';
// import { useSelector } from 'react-redux';

function DocumentTypeSelector() {
  const selectedHotel = useSelector((state) => state.checking.hotel);
  const [dataDocumentType, setDataDocumentType] = useState({
    optionDocument: 1,
    documentOne: null,
    documentTwo: null,
    documentOneLabel: '',
    documentTwoLabel: '',
  });

  // Hoteles donde aplican reglas específicas según nacionalidad
  const hotelsGroupA = ['M1', 'M2', 'M3'];
  const hotelsGroupB = ['M4', 'M5'];

  const { t } = useTranslation();
  // const { nationality } = useSelector((state) => state.ocr);
  // Usa useFormContext para acceder a los métodos del formulario
  const {
    register,
    formState: { errors },
    watch,
    setValue,
    trigger,
  } = useFormContext();

  const {
    ref: refDocumentType,
    onChange: onChangeDocumentType,
    onBlur: onBlurDocumentType,
    name: nameDocumentType,
  } = register('documentType', {
    required: 'Seleccionar tipo de documento',
  });
  const selectedNationality = watch('nationality') || '';
  const documentType = watch('documentType') || '';

  // Controla visibilidad Card document cuando se selecciona nacionalidad
  useEffect(() => {
    if (!isEmptyObject(selectedNationality)) {
      switch (selectedNationality.iso2) {
        case 'MX':
          setDataDocumentType({
            optionDocument: 2,
            documentOne: IconId,
            documentTwo: IconPassport,
            documentOneLabel: 'INE',
            documentTwoLabel: 'PASSPORT',
          });
          break;
        case 'DO':
          setDataDocumentType({
            optionDocument: 3,
            documentOne: IconId,
            documentTwo: IconPassport,
            documentOneLabel: 'CEDULA',
            documentTwoLabel: 'PASSPORT',
          });
          break;
        default:
          setDataDocumentType({
            optionDocument: 1,
            documentOne: IconId,
            documentTwo: IconPassport,
            documentOneLabel: 'Foto',
            documentTwoLabel: 'PASSPORT',
          });
          break;
      }
    }
  }, [selectedNationality]);

  useEffect(() => {
    if (documentType !== '') {
      setValue('documentType', documentType);
      trigger();
    }
  }, [trigger, setValue, documentType, dataDocumentType]);

  // Ocultar INE/Cédula según nacionalidad y grupo de hotel
  const hideDocument =
    (selectedNationality.iso2 === 'MX' && hotelsGroupA.includes(selectedHotel)) ||
    (selectedNationality.iso2 === 'DO' && hotelsGroupB.includes(selectedHotel));

  return (
    <Row className="my-3">
      <Col
        xs={dataDocumentType.optionDocument === 1 || hideDocument ? 12 : 6}
        sm={dataDocumentType.optionDocument === 1 || hideDocument ? 12 : 6}
        lg={dataDocumentType.optionDocument === 1 || hideDocument ? 12 : 6}
        className="px-0"
      >
        <div className="d-flex flex-column">
          <div className="text-center mb-2">
            <img src={dataDocumentType.documentTwo} alt="IconPassport" style={{ width: '80px' }} />
          </div>
          <Form.Group className="py-1 mx-auto" controlId="documentPASSPORT">
            <Form.Check type="radio" id="documentPASSPORT" className="ps-0">
              <Form.Check.Label className="custom-input-radio app-fw-notosans-bold app-txt-granite-80-dark">
                <Form.Check.Input
                  ref={refDocumentType}
                  onChange={onChangeDocumentType}
                  onBlur={onBlurDocumentType}
                  name={nameDocumentType}
                  type="radio"
                  value="PASSPORT"
                />
                <span className="checkmark" />
                {t(`TXT_${dataDocumentType.documentTwoLabel}`)}
              </Form.Check.Label>
            </Form.Check>
          </Form.Group>
        </div>
      </Col>
      <Col
        xs={6}
        sm={6}
        lg={6}
        className={`px-0 ${dataDocumentType.optionDocument === 1 || hideDocument ? 'd-none' : ''}`}
      >
        <div className="d-flex flex-column">
          <div className="d-flex justify-content-center align-items-center mb-2">
            <img src={dataDocumentType.documentOne} alt="IconId" style={{ width: '80px' }} />
          </div>
          <Form.Group className="py-1 mx-auto" controlId="documentINE">
            <Form.Check type="radio" id="documentINE" className="ps-0">
              <Form.Check.Label className="custom-input-radio app-fw-notosans-bold app-txt-granite-80-dark">
                <Form.Check.Input
                  ref={refDocumentType}
                  onChange={onChangeDocumentType}
                  onBlur={onBlurDocumentType}
                  name={nameDocumentType}
                  type="radio"
                  value={dataDocumentType.optionDocument === 2 ? 'INE' : 'CEDULA'}
                />
                <span className="checkmark" />
                {t(`TXT_${dataDocumentType.documentOneLabel}`)}
              </Form.Check.Label>
            </Form.Check>
          </Form.Group>
        </div>
      </Col>
    </Row>
  );
}

export default DocumentTypeSelector;
